import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  FeedbacksFilter,
  FeedbackDetails,
  OwnerCleanerCaretakerFeedbackEmailReplyDto,
  ExternalEmailFeedbackEmailReplyDto,
} from '../../features/feedbacks/FeedbacksSlice';

export function fetchPendingFeedbacksCount() {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .get('/customerfeedback/customerfeedbacks/getpendingfeedbackscount', config)
    .then(res => res.data);
}

export function fetchFeedbacks(feedbacksFilter: FeedbacksFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/customerfeedback/customerfeedbacks/getcustomerfeedbacks',
      feedbacksFilter,
      config,
    )
    .then(res => res.data);
}

export function fetchFeedbackDetails(feedbackId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { feedbackId },
  };

  return axios
    .get('/customerfeedback/customerfeedbacks/getcustomerfeedback', config)
    .then(res => res.data);
}

export function fetchFeedbackDetailsAsPdf(feedbackId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { feedbackId },
    responseType: 'arraybuffer' as const, // <-- important
  };

  return axios
    .get('/customerfeedback/customerfeedbacks/downloadfeedbackpdf', config)
    .then(res => res.data);
}

export function updateFeedbackSentToOwner(feedbackId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { feedbackId },
  };

  return axios
    .get(
      '/customerfeedback/customerfeedbacks/UpdateCustomerFeedbackSentToOwner',
      config,
    )
    .then(res => res.data);
}

export function updateFeedbackSentToMaintainer(feedbackId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { feedbackId },
  };

  return axios
    .get(
      '/customerfeedback/customerfeedbacks/UpdateCustomerFeedbackSentToMaintainer',
      config,
    )
    .then(res => res.data);
}
export function updateFeedbackSentToCleaner(feedbackId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { feedbackId },
  };

  return axios
    .get(
      '/customerfeedback/customerfeedbacks/UpdateCustomerFeedbackSentToCleaner',
      config,
    )
    .then(res => res.data);
}

export function updateFeedbackSentToExternalEmailAddress(
  feedbackId: string,
  emailAddress: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { feedbackId, emailAddress },
  };

  return axios
    .get(
      '/customerfeedback/customerfeedbacks/UpdateCustomerFeedbackSentToOtherEmailAddress',
      config,
    )
    .then(res => res.data);
}

export function doSendFeedbackToOwner(
  payload: OwnerCleanerCaretakerFeedbackEmailReplyDto,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/customerfeedback/customerfeedbacks/sendfeedbacktoowner',
      payload,
      config,
    )
    .then(res => res.data);
}

export function doSendFeedbackToCaretaker(
  payload: OwnerCleanerCaretakerFeedbackEmailReplyDto,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/customerfeedback/customerfeedbacks/sendfeedbacktocaretaker',
      payload,
      config,
    )
    .then(res => res.data);
}

export function doSendFeedbackToCleaner(
  payload: OwnerCleanerCaretakerFeedbackEmailReplyDto,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/customerfeedback/customerfeedbacks/sendfeedbacktocleaner',
      payload,
      config,
    )
    .then(res => res.data);
}

export function doSendFeedbackToExternalEmail(
  payload: ExternalEmailFeedbackEmailReplyDto,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/customerfeedback/customerfeedbacks/sendfeedbacktoexternal',
      payload,
      config,
    )
    .then(res => res.data);
}

export function updateFeedback(feedbackData: FeedbackDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/customerfeedback/customerfeedbacks/updatecustomerfeedback',
      feedbackData,
      config,
    )
    .then(res => res.data);
}

export function deleteFeedback(feedbackId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { feedbackId },
  };

  return axios
    .delete('/customerfeedback/customerfeedbacks/deletefeedback', config)
    .then(res => res.data);
}
